






































































import Vue from 'vue';
import ruleClient from '../../apis';
import customerClient from '../../../customer/apis';
import settingsClient from '../../../settings/apis';
import { ScheduleRule, ScheduleRuleType } from '../../models/ScheduleRule';
import { ScheduleEventType } from '../../models/ScheduleEventParam';
import scheduleRuleVuex from '../../vuex/common';
import RuleItem from './RuleItem.vue';
import CustomerRemark from '../../../customer/models/CustomerRemark';

const eventCount: number | undefined = undefined;
const periodicCount: number | undefined = undefined;
const timeFieldCount: number | undefined = undefined;
const totalCount: number | undefined = undefined;
const ruleType: ScheduleRuleType | null = null;
const isDisabled = false;
const loaded = false;
const topicsLoaded = false;
const remarks: CustomerRemark[] = [];

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    RuleItem,
  },
  data() {
    return {
      eventCount,
      periodicCount,
      timeFieldCount,
      totalCount,
      ruleType,
      ScheduleRuleType,
      isDisabled,
      loaded,
      topicsLoaded,
      remarks,
      page: 1,
      total: 0,
      size: 10,
      keyword: null,
    };
  },
  computed: {
    isVerifiedService(): boolean {
      return this.accountState.account.weixinType === 1 &&
        this.accountState.account.isVerified;
    },
  },
  methods: {
    changePage(page: number) {
      if (this.page !== page) {
        this.page = page;
        this.loadRules();
      }
    },
    getRulesByKeyWord() {
      const params = {
        keyword: this.keyword,
      };
      ruleClient.getRulesByKeyword(params).success((r: any) => {
        this.$store.commit('SET_SCHEDULE_RULES', this.decorateRules(r.rules, r.remarks));
        this.loaded = true;
      });
    },
    loadRules() {
      const params = this.ruleType ? {
        ruleType: this.ruleType,
        page: this.page,
        size: this.size,
      } : {
        page: this.page,
        size: this.size,
      };
      customerClient.getMemberCards().success((r: any) => {
        this.$store.commit('SET_MEMBER_CARDS', r);
        ruleClient.getRules(params).success((r: any) => {
          this.$store.commit('SET_SCHEDULE_RULES', this.decorateRules(r.rules, r.remarks));
          this.eventCount = r.counts[ScheduleRuleType.Event] || 0;
          this.periodicCount = r.counts[ScheduleRuleType.Periodic] || 0;
          this.timeFieldCount = r.counts[ScheduleRuleType.TimeField] || 0;
          this.totalCount = (Object.values(r.counts) as number[]).reduce((a: number, b: number) => a + b, 0);
          if (this.ruleType) {
            this.total = r.counts[this.ruleType] || 0;
          } else {
            this.total = this.totalCount;
          }
          this.loaded = true;
        });
      });
    },
    decorateRules(rules: any[], rmks: any): ScheduleRule[] {
      const remarks: CustomerRemark[] = [];
      Object.keys(rmks).forEach((r: any) => {
        remarks.push({
          id: parseInt(r),
          remarkName: rmks[r],
        } as CustomerRemark);
      });
      this.remarks = remarks;
      return rules.map((rule: any) => {
        const r = rule.scheduleRule;
        if (r.ruleType === ScheduleRuleType.TimeField) {
          r.ruleContext.TimeFieldBased.prop = this.customerState.props.find(p => { 
            return p.fieldName === r.ruleContext.TimeFieldBased.field; 
          });
        }
        if (r.ruleType === ScheduleRuleType.Event &&
          r.ruleContext.EventTriggered.eventType === ScheduleEventType.RemarkAppended) {
          const remarkId = r.ruleContext.EventTriggered.param.RemarkAppended.remarkId;
          const remark = remarks.find((r: CustomerRemark) => r.id === remarkId);
          if (remark) {
            r.ruleContext.EventTriggered.param.RemarkAppended.remarkName = remark!.remarkName;
          }
        }
        if (r.ruleType === ScheduleRuleType.Event &&
          r.ruleContext.EventTriggered.eventType === ScheduleEventType.MemberLevelUp) {
          const memberCard = this.customerState.memberCards.find((card: any) => {
            return card.level === r.ruleContext.EventTriggered.param.MemberLevelUp.level;
          });
          if (memberCard) {
            r.ruleContext.EventTriggered.param.MemberLevelUp.title = memberCard!.title;
          }
        }
        rule['scheduleRule'] = r;
        return rule;
      });
    },
    showEdit(rule: ScheduleRule) {
      this.$store.commit('UPDATE_SCHEDULE_RULE', {
        rule,
        remarks: this.remarks,
      });
      this.$emit('showEdit');
    },
    showCreate() {
      this.$emit('showCreate');
    },
    selectDisabled() {
      this.isDisabled = true;
      ruleClient.getDisableRules({}).success((r: any) => {
        this.$store.commit('SET_SCHEDULE_RULES', this.decorateRules(r.rules.map((r: any) => {
          return {
            scheduleRule: r,
          };
        }), r.remarks));
        this.eventCount = r.counts[ScheduleRuleType.Event] || 0;
        this.periodicCount = r.counts[ScheduleRuleType.Periodic] || 0;
        this.timeFieldCount = r.counts[ScheduleRuleType.TimeField] || 0;
        this.totalCount = (Object.values(r.counts) as number[]).reduce((a: number, b: number) => a + b, 0);
        this.loaded = true;
      });
    },
    loadTopics() {
      settingsClient.getTopics().success((r: any) => {
        this.$store.commit('SET_TOPICS', r.topics);
        this.topicsLoaded = true;
      });
    },
  },
  mounted() {
    customerClient.getProps().success((r) => {
      this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      this.loadRules();
    });
    this.loadTopics();
  },
  watch: {
    ruleType() {
      this.loadRules();
    },
    keyword() {
      if (this.keyword) {
        this.getRulesByKeyWord();
      } else {
        this.loadRules();
      }
    },
    isDisabled(status: boolean) {
      if (!status) {
        this.loadRules();
      }
    },
  },
});
